import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu, Segment } from 'semantic-ui-react';
import i18next from 'i18next';
import { ImageInput } from '../common';
import ExternalLinks from './ExternalLinks';
import { uploadCommonImage } from '../../actions';

class Tools extends Component {
    state = { activeItem: 'images' }

    renderContent(activeItem) {
        if (activeItem === 'images') {
            return (
                <div style={{ padding: 10 }}>
                    <ImageInput
                        resizeMode
                        handleFileUpload={this.props.uploadCommonImage}
                    />
                </div>
            );
        } else if (activeItem === 'links') {
            return (
                <div style={{ padding: 10 }}>
                    <ExternalLinks />
                </div>
            );
        }

        return null;
    }

    render() {
        const { activeItem } = this.state;

        return (
            <div style={{ padding: 10 }}>
                <Menu pointing>
                    <Menu.Item name='Common images' active={activeItem === 'images'} onClick={() => this.setState({ activeItem: 'images' })} />
                    <Menu.Item name='External links' active={activeItem === 'links'} onClick={() => this.setState({ activeItem: 'links' })} />
                </Menu>

                <Segment>
                    {this.renderContent(activeItem)}
                </Segment>
            </div>
        );
    }
}

Tools.propTypes = {
    uploadCommonImage: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {};
};

export default connect(mapStateToProps, { uploadCommonImage })(Tools);
